const isEnglishString = (str) => {
  var regex = /^[A-Za-z0-9]*$/;
  return regex.test(
    str.replace(/[\s~`!@#$%^&*(){}\[\];:"'<,.>?\/\\|_+=-]/g, "")
  );
};

export default isEnglishString;
